import {
  getDeniedBookingMessage,
  getDeniedPaymentMessage,
  getErrorMessage,
  getReviewBookingMessage,
  getReviewPaymentMessage,
} from './messages';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoIcon from '@mui/icons-material/Info';

import { sxStyle } from './styles';

// Espeja STATUS_IDS de api-hotels-hub
// (lib/application/use-cases/integrations/utils/status/status-ids.js),
// que es el valor que llega como bookingStatus (id_status / agency_status /
// notification_status).
export const BOOKING_STATUS = {
  CONFIRM: 1,
  CANCELLED: 2,
  PRE_BOOKING: 3,
  FAILED: 4,
  DENIED: 5,
  REQUIRES_REVIEW: 6,
};

export const HEADER_COMMON = {
  CONFIRMED: {
    icon: CheckIcon,
    iconStyle: sxStyle.successIcon,
    badgeStyle: sxStyle.successBadgeBg,
    showBookingData: true,
  },

  DENIED: {
    icon: CloseIcon,
    iconStyle: sxStyle.errorIcon,
    badgeStyle: sxStyle.deniedBadgeBg,
  },

  ERROR: {
    icon: WarningAmberIcon,
    iconStyle: sxStyle.warningIcon,
    badgeStyle: sxStyle.warningBadgeBg,
  },

  REVIEW: {
    icon: InfoIcon,
    iconStyle: sxStyle.reviewIcon,
    badgeStyle: sxStyle.reviewBadgeBg,
  },
};

export const DEFAULT_ERROR = {
  ...HEADER_COMMON.ERROR,
  title: 'Falló la creación de tu reserva',
  message:
    'Ocurrió un inconveniente con tu reserva. Por favor, intentá nuevamente.',
};

export const HEADER_MESSAGES = {
  BOOKING: {
    [BOOKING_STATUS.CONFIRM]: {
      ...HEADER_COMMON.CONFIRMED,
      title: '¡Tu reserva se confirmó exitosamente!',
    },
    [BOOKING_STATUS.CANCELLED]: {
      ...HEADER_COMMON.DENIED,
      title: 'No pudimos confirmar tu reserva',
      subtitle: getDeniedBookingMessage,
      showNewSearch: true,
    },
    [BOOKING_STATUS.PRE_BOOKING]: {
      ...HEADER_COMMON.CONFIRMED,
      title: '¡Tu reserva se confirmó exitosamente!',
    },
    [BOOKING_STATUS.FAILED]: {
      ...HEADER_COMMON.ERROR,
      title: ({ errorCopy }) => errorCopy?.title,
      subtitle: getErrorMessage,
      showNewSearch: true,
    },
    [BOOKING_STATUS.DENIED]: {
      ...HEADER_COMMON.DENIED,
      title: 'No pudimos confirmar tu reserva',
      subtitle: getDeniedBookingMessage,
      showNewSearch: true,
    },
    [BOOKING_STATUS.REQUIRES_REVIEW]: {
      ...HEADER_COMMON.REVIEW,
      title: 'Reserva pendiente de revisión',
      subtitle: getReviewBookingMessage,
      showBookingData: true,
    },
  },

  PAYMENT: {
    [BOOKING_STATUS.CONFIRM]: {
      ...HEADER_COMMON.CONFIRMED,
      title: '¡Tu compra se confirmó exitosamente!',
    },
    [BOOKING_STATUS.CANCELLED]: {
      ...HEADER_COMMON.DENIED,
      title: 'No pudimos confirmar tu reserva',
      subtitle: getDeniedPaymentMessage,
      showNewSearch: true,
    },
    [BOOKING_STATUS.PRE_BOOKING]: {
      ...HEADER_COMMON.CONFIRMED,
      title: '¡Tu compra se confirmó exitosamente!',
    },
    [BOOKING_STATUS.FAILED]: {
      ...HEADER_COMMON.ERROR,
      title: ({ errorCopy }) => errorCopy?.title,
      subtitle: getErrorMessage,
      showNewSearch: true,
    },
    [BOOKING_STATUS.DENIED]: {
      ...HEADER_COMMON.DENIED,
      title: 'No pudimos confirmar tu reserva',
      subtitle: getDeniedPaymentMessage,
      showNewSearch: true,
    },
    [BOOKING_STATUS.REQUIRES_REVIEW]: {
      ...HEADER_COMMON.REVIEW,
      title: 'Tu reserva requiere asistencia',
      subtitle: getReviewPaymentMessage,
      showBookingData: true,
    },
  },
};
